




















































































import { Vue, Component, Ref } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import StudentForm from "@/components/students/StudentForm.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { courseApi, studentDocumentApi } from "@/getinfo-api";
import { StudentCreate } from "@/api-v2/course/models";
import { Student as IStudent } from "@/api-v2/course/models";
import { Student as IStudentDocumentInfo } from "@/api-v2/student-document-info/models/student";
import CustomButton from "@/components/form/CustomButton.vue";
import StudentDocInfoPassport from "@/components/students/StudentDocInfoPassport.vue";
import StudentDocInfoEducation from "@/components/students/StudentDocInfoEducation.vue";
import CField from "@/components/form/CField.vue";

@Component({
  components: {
    CField,
    StudentDocInfoEducation,
    StudentDocInfoPassport,
    CustomButton,
    CPageButtons,
    StudentForm,
    CPage
  }
})
export default class StudentNew extends Vue {
  @Ref("passportForm") passportForm?: StudentDocInfoPassport;
  @Ref("educationForm") educationForm?: StudentDocInfoEducation;
  form!: StudentCreate;
  studentDocumentInfo!: IStudentDocumentInfo;
  isLoading: boolean = false;
  student!: IStudent;
  activeTab: number = 0;
  other: any = {};

  data() {
    return {
      form: undefined,
      studentDocumentInfo: undefined,
      student: undefined
    };
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  decline() {
    this.$router.push({ name: "students" });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "students" },
        label: this.$tc(this.$translate.Students)
      },
      {
        label: this.$tc(this.$translate.Add)
      }
    ];
  }

  async createStudentDocumentInfo() {
    try {
      this.isLoading = true;
      const { data } = await studentDocumentApi.getStudent(this.student.id);
      data.education = this.educationForm?.docInfoEducation;
      data.passport = this.passportForm?.docInfoPassport;
      data.citizenship = this.other?.citizenship;
      data.job = this.other?.job;
      data.address = this.other?.address;
      data.postAddress = this.other?.postAddress;
      data.position = this.other?.position;
      data.snils = this.other?.snils;

      await studentDocumentApi.editStudent(data.id, data);
      await this.$store.dispatch("successToast", {
        message: this.$tc(
          this.$translate.TheInformationHasBeenSuccessfullyChanged
        )
      });
      await this.$router.push({
        name: "student",
        params: { id: this.student.id }
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async createStudent() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    try {
      this.isLoading = true;
      const { data } = await courseApi.Student.createStudent(this.form);
      this.student = data;
      await this.$store.dispatch("successToast", {
        message: this.$tc(this.$translate.Created)
      });
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.activeTab = 0;
      this.isLoading = false;
    }
  }
}
